import { overlay } from 'overlay-kit';

import { RenameBoardDialog } from './rename-board-dialog';

export function requestRenameBoardDialog({
  initialTitle,
  onSave,
}: {
  initialTitle: string;
  onSave: (title: string) => Promise<void>;
}): Promise<void> {
  return overlay.openAsync<void>(({ isOpen, close, unmount }) => (
    <RenameBoardDialog
      initialTitle={initialTitle}
      isOpen={isOpen}
      onCancel={close}
      onSave={async (title) => {
        await onSave(title);
        close();
      }}
      onUnmount={unmount}
    />
  ));
}
